import { render, staticRenderFns } from "./demandOrderList.vue?vue&type=template&id=62db8b11&scoped=true"
import script from "./demandOrderList.vue?vue&type=script&lang=js"
export * from "./demandOrderList.vue?vue&type=script&lang=js"
import style0 from "./demandOrderList.vue?vue&type=style&index=0&id=62db8b11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db8b11",
  null
  
)

export default component.exports